import { isBoolean as p } from "./index138.js";
import { isEmpty as r } from "./index72.js";
import { isNill as c } from "./index139.js";
import { isString as f } from "./index71.js";
function E(s) {
  return n(s, 1);
}
function n(s, m) {
  const i = [];
  return f(s) ? s.trim().split(" ").forEach((t) => {
    const o = t.trim();
    !r(o) && i.push(o);
  }) : Array.isArray(s) ? m < 10 && s.forEach((t) => {
    const o = n(t, m + 1);
    !r(o) && i.push(o);
  }) : !c(s) && !p(s) && Object.keys(s).forEach((t) => {
    s[t] && t.trim().split(" ").forEach((o) => {
      const a = o.trim();
      !r(a) && i.push(a);
    });
  }), i.join(" ");
}
export {
  E as parseClassNames
};
